<template>
  <div>
    <kst-number-with-date view-mode
      :catalog="Catalog"
      :data="details"
      dateField="Date"
      numberField="AdjNumber"
    />

    <kst-output field="Comment" :data="details" :catalog="Catalog"/>
    <kst-created :data="details"/>
    <kst-output field="WarehouseID" :data="details" :catalog="Catalog"/>
  </div>
</template>

<script>
import Catalog from "../HpadCatalog.js";

export default {
  props: {
    details: Object
  },
  data: () => ({
    Catalog: Catalog
  })
}
</script>